module.exports = __webpack_public_path__ + "static/media/3_col_5.f4e860a4.jpg";